export enum CLAIM {
  UNAVAILABLE = 'UNAVAILABLE',
  AVAILABLE = 'AVAILABLE',
  ALL_IN_ROUND_CLAIMED = 'ALL_IN_ROUND_CLAIMED',
  ALL_CLAIMED = 'ALL_CLAIMED',
  NOT_LISTED = 'NOT_LISTED',
}

export enum AIRDROP {
  NOT_STARTED = 'NOT_STARTED',
  HAS_STARTED = 'HAS_STARTED',
  HAS_FINISHED = 'HAS_FINISHED',
}
